const API_ENDPOINT = window.apiUrl + "/api/product/filter";

// State management
let currentState = {
  filters: {
    material: [],
    shape: [],
    back: [],
    type: [],
    surface: [],
    excludeCollection: ["sample-products"],
  },
  title: "",
  sortBy: "min_price",
  sortOrder: "desc",
  cursor: null,
  isLoading: false,
  direction: null,
};

// Size buttons (surface filter)
const sizeButtons = document.querySelectorAll(".page .size-btn");
sizeButtons.forEach((btn) => {
  btn.addEventListener("click", function () {
    if (this.classList.contains("active")) {
      // If already active, remove active and clear surface filter
      this.classList.remove("active");
      currentState.filters.surface = [];
    } else {
      // Remove active from all buttons and add to clicked button
      sizeButtons.forEach((b) => b.classList.remove("active"));
      this.classList.add("active");
      currentState.filters.surface = [this.getAttribute("data-value")];
    }
  });
});

// Sort buttons
document.querySelectorAll(".sort-btn").forEach((btn, index) => {
  btn.addEventListener("click", function () {
    document
      .querySelectorAll(".sort-btn")
      .forEach((b) => b.classList.remove("active"));
    this.classList.add("active");

    // Map sort buttons to API values
    switch (index) {
      case 0: // 人気順 - default price desc
        currentState.sortBy = "rank";
        currentState.sortOrder =
          currentState.sortOrder === "asc" ? "desc" : "asc";
        break;
      case 1: // 価格 - sort by min_price as fallback
        currentState.sortBy = "min_price";
        currentState.sortOrder =
          currentState.sortOrder === "asc" ? "desc" : "asc";
        break;
      case 2: // サイズ - sort by number_size as fallback
        currentState.sortBy = "number_size";
        currentState.sortOrder =
          currentState.sortOrder === "asc" ? "desc" : "asc";
        break;
    }

    // Update icon rotation for price sort
    const sortIcon = this.querySelector(".sort-icon");
    if (sortIcon) {
      if (currentState.sortOrder === "asc") {
        sortIcon.classList.add("asc");
      } else {
        sortIcon.classList.remove("asc");
      }
    }

    // Re-fetch with new sort
    loadProducts(true);
  });
});

// Checkbox handling
document
  .querySelectorAll('.page .filter-content input[type="checkbox"]')
  .forEach((input) => {
    input.addEventListener("change", function () {
      const checkboxVisual = this.parentNode.querySelector(".checkbox");
      const filterName = this.name;
      const value = this.value;

      if (this.checked) {
        checkboxVisual.classList.add("checked");
        if (!currentState.filters[filterName].includes(value)) {
          currentState.filters[filterName].push(value);
        }
      } else {
        checkboxVisual.classList.remove("checked");
        currentState.filters[filterName] = currentState.filters[
          filterName
        ].filter((v) => v !== value);
      }
    });
  });

// Search input - common-sidebar-filterの中にある
const searchInput = document.querySelector("#page-search-input");
// if (searchInput) {
//     let searchTimeout;
//     searchInput.addEventListener('input', function() {
//         clearTimeout(searchTimeout);
//         searchTimeout = setTimeout(() => {
//             currentState.title = this.value.trim();
//             loadProducts(true); // Reset pagination
//         }, 500); // Debounce 500ms
//     });
// }

// Search button
function handleSearch() {
  currentState.title = searchInput.value.trim();
  searchInput.value = currentState.title;
  resetInputFilter();

  loadProducts(true);
}
const searchButton = document.querySelector("#page-search-addon");
if (searchButton) {
  searchButton.addEventListener("click", handleSearch);
}

if (searchInput) {
  searchInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      handleSearch();
    }
  });
}

// Filter apply button
const filterApplyBtn = document.querySelector(
  ".page .filter-apply-btn a.btn-main",
);
if (filterApplyBtn) {
  filterApplyBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    resetInputSearch();

    await loadProducts(true); // Reset pagination when applying filters
  });
}

// Pagination buttons
const prevButtons = document.querySelectorAll(".pagination-prev");
const nextButtons = document.querySelectorAll(".pagination-next");

prevButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    if (!btn.disabled && !currentState.isLoading) {
      loadPreviousPage();
    }
  });
});

nextButtons.forEach((btn) => {
  btn.addEventListener("click", () => {
    if (!btn.disabled && !currentState.isLoading) {
      loadNextPage();
    }
  });
});

// Main function to load products
async function loadProducts(resetPagination = false) {
  if (currentState.isLoading) return;

  currentState.isLoading = true;

  if (resetPagination) {
    currentState.cursor = null;
  }

  try {
    const requestData = {
      ...currentState.filters,
      title: currentState.title || undefined,
      sortBy: currentState.sortBy,
      sortOrder: currentState.sortOrder,
      cursor: currentState.cursor,
      direction: currentState.direction,
    };

    console.log("[Products] APIリクエストデータ:", requestData);

    // Update URL with current state
    updateURLParams(requestData);

    const result = await getProductsWithFilter(requestData);

    console.log("[Products] APIレスポンス:", {
      success: result.success,
      productCount: result.data?.products?.length,
      products: result.data?.products,
    });

    if (result.success) {
      renderProducts(result.data.products);
      updatePagination(result.data.pagination);
      updateProductsHeader(
        result.data.pagination.display.currentPage,
        result.data.pagination.display.totalPages,
      );

      // Store cursors for pagination
      currentState.nextCursor = result.data.pagination.nextCursor;
      currentState.previousCursor = result.data.pagination.previousCursor;
    } else {
      showError(result.error);
    }
  } catch (error) {
    showError("商品の読み込みに失敗しました: " + error.message);
  } finally {
    currentState.isLoading = false;
  }
}

async function loadNextPage() {
  if (currentState.nextCursor) {
    currentState.cursor = currentState.nextCursor;
    currentState.direction = "next";
    await loadProducts(false);
  }
}

async function loadPreviousPage() {
  if (currentState.previousCursor) {
    currentState.cursor = currentState.previousCursor;
    currentState.direction = "prev";
    await loadProducts(false);
  }
}

// API call function
async function getProductsWithFilter(formData) {
  showLoading();
  try {
    const response = await fetch(API_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      const result = await response.json();
      return { success: true, data: result };
    } else {
      let errorData = {};
      try {
        errorData = await response.json();
      } catch (e) {}

      const errorMessage =
        errorData.message ||
        `HTTP Error: ${response.status} ${response.statusText}`;
      return {
        success: false,
        error: errorMessage,
      };
    }
  } catch (error) {
    return {
      success: false,
      error: `Network error: ${error.message}`,
    };
  } finally {
    closeLoading();
  }
}

// UI rendering functions
function renderProducts(products) {
  const productsContainer = document.querySelector("#products-grid");
  const productsSection = document.querySelector(".products-list");
  const noResultsDiv = document.querySelector("#no-results-message");
  const paginationEnd = document.querySelector("#pagination-end");

  if (!productsContainer || !productsSection) return;

  // Clear existing content
  productsContainer.innerHTML = "";

  // Check if no products
  if (!products || products.length === 0) {
    // Hide products section
    productsSection.classList.add("d-none");
    noResultsDiv.classList.remove("d-none");
    productsContainer.innerHTML = "";

    return;
  }

  // Show products section if hidden
  productsSection.classList.remove("d-none");
  noResultsDiv.classList.add("d-none");
  paginationEnd.classList.add("d-none");

  const fragment = document.createDocumentFragment();

  // Render products
  products.forEach(({ node }) => {
    const div = document.createElement("div");
    div.className = "h-100";
    div.innerHTML = `
                <div class="product-item h-100" data-product-id="${node.id}">
                    <div class="card h-100 position-relative">
                        <a href="/products/${node.handle}" class="card-link text-decoration-none">
                            <img src="${node.image}" class="product-img" alt="${node.title}" width="" height="">
                            <div class="card-body">
                                <div class="product-info text-center">
                                    <div class="product-name">${node.title}</div>
                                    <div class="product-price">
                                        <span class="price-symbol num">1点(税込)</span>
                                        <span class="price-amount num">${node.minPrice ? node.minPrice : ""}</span>
                                        <span class="price-unit">円〜</span>
                                    </div>
                                </div>
                            </div>
                        </a>
                        <button class="favorite-btn position-absolute top-2 end-2" data-product-id="${normalizeProductId(node.id)}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" class="bi bi-heart　cls-1"
                                viewBox="0 0 25.02 20.1">
                                <defs>
                                    <style>
                                        .cls-1 {
                                            fill: #d3d3d3;
                                        }
                                    </style>
                                </defs>
                                <g id="main">
                                    <path class="cls-1"
                                        d="M13.65,19.73c-.68.49-1.59.49-2.27,0l-2.68-1.93c-.07-.05-1.74-1.26-3.43-2.72-1.11-.96-2-1.82-2.71-2.62-.63-.72-2.56-2.91-2.56-5.94C0,2.92,2.92,0,6.52,0c2.69,0,4.99,1.62,5.99,3.94,1-2.32,3.31-3.94,5.99-3.94,3.6,0,6.52,2.92,6.52,6.52,0,3.03-1.92,5.22-2.56,5.94-.71.8-1.59,1.66-2.71,2.62-1.69,1.45-3.36,2.66-3.43,2.72l-2.68,1.93Z" />
                                </g>
                            </svg>
                        </button>
                </div>
        `;
    fragment.appendChild(div);
    // productsContainer.insertAdjacentHTML('beforeend', productHtml);
  });

  setTimeout(() => {
    productsContainer.innerHTML = "";
    productsContainer.appendChild(fragment);
    paginationEnd.classList.remove("d-none");
    attachFavoriteListeners();
  }, 100);
}

function updatePagination(paginationData) {
  const prevButtons = document.querySelectorAll(".pagination-prev");
  const nextButtons = document.querySelectorAll(".pagination-next");

  prevButtons.forEach((btn) => {
    btn.disabled = !paginationData.hasPreviousPage;
    btn.classList.toggle("disabled", !paginationData.hasPreviousPage);
  });

  nextButtons.forEach((btn) => {
    btn.disabled = !paginationData.hasNextPage;
    btn.classList.toggle("disabled", !paginationData.hasNextPage);
  });
}

function updateProductsHeader(currentPage, totalPages) {
  const productCount = document.querySelectorAll(".product-count");
  productCount.forEach((subtitle) => {
    if (subtitle && meta) {
      subtitle.textContent = `ページ: ${currentPage} / ${totalPages}`;
    }
  });
}

function showError(message) {
  // You can implement a toast/modal here
  alert("エラー: " + message);
}

// Initialize checkboxes state based on HTML
function initializeFilters() {
  if (initializeFromURL()) {
    return;
  }
  // Reset filters state first
  currentState.filters = {
    material: ["クリア"],
    shape: ["円形"],
    back: ["安全ピン"],
    type: ["缶バッジ"],
    surface: ["〜29mm"],
    excludeCollection: ["sample-products"],
  };

  // Sync UI with the default state
  syncUIWithState();
}

function resetInputFilter() {
  currentState.filters = {
    material: [],
    shape: [],
    back: [],
    type: [],
    surface: [],
    excludeCollection: ["sample-products"],
  };

  document
    .querySelectorAll('.page .filter-content input[type="checkbox"]')
    .forEach((input) => {
      input.checked = false;
      const checkboxVisual = input.parentNode.querySelector(".checkbox");
      checkboxVisual.classList.remove("checked");
    });

  document.querySelectorAll(".page .size-btn").forEach((btn, index) => {
    btn.classList.remove("active");
    // if (index === 0) {
    //     btn.classList.add('active');
    //     currentState.filters.surface = [btn.getAttribute('data-value')];
    // } else {
    //     btn.classList.remove('active');
    // }
  });
}

function resetInputSearch() {
  currentState.title = "";

  const searchInput = document.querySelector("#page-search-input");
  if (searchInput) {
    searchInput.value = "";
  }
}

function resetSort() {
  currentState.sortBy = "min_price";
  currentState.sortOrder = "desc";

  document.querySelectorAll(".sort-btn").forEach((btn, index) => {
    if (index === 1) {
      btn.classList.add("active");
    } else {
      btn.classList.remove("active");
    }
  });
}

function resetPagination() {
  currentState.cursor = null;
}

function resetFilters() {
  resetInputFilter();
  resetInputSearch();
  resetSort();
  resetPagination();

  // Reload products
  loadProducts(true);
}

// Initialize on page load
document.addEventListener("DOMContentLoaded", function () {
  // Initialize filter state from HTML
  initializeFilters();

  // Auto-load products with default filters
  loadProducts(true);
});

// Function to update URL parameters
function updateURLParams(requestData) {
  const url = new URL(window.location);
  const params = new URLSearchParams();

  // Handle array filters - convert to comma-separated strings
  ["material", "shape", "back", "type", "surface", "excludeCollection"].forEach(
    (filterKey) => {
      if (requestData[filterKey] && requestData[filterKey].length > 0) {
        params.set(filterKey, requestData[filterKey].join(","));
      }
    },
  );

  // Handle other parameters
  if (requestData.title) {
    params.set("title", requestData.title);
  }

  if (requestData.sortBy) {
    params.set("sortBy", requestData.sortBy);
  }

  if (requestData.sortOrder) {
    params.set("sortOrder", requestData.sortOrder);
  }

  if (requestData.cursor) {
    params.set("cursor", requestData.cursor);
  }

  if (requestData.direction) {
    params.set("direction", requestData.direction);
  }

  // Update URL without page reload
  url.search = params.toString();
  window.history.pushState({}, "", url.toString());
}

// Function to initialize state from URL parameters
function initializeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  let hasParams = false;

  console.log("[Products] URLパラメータ:", window.location.search);
  console.log(
    "[Products] 全てのURLパラメータ:",
    Array.from(urlParams.entries()),
  );

  const title = urlParams.get("title");
  if (title) {
    currentState.title = title;
    hasParams = true;
    console.log("[Products] titleパラメータを読み取りました:", title);
    console.log("[Products] currentState.title にセット:", currentState.title);
  } else {
    console.log("[Products] titleパラメータが見つかりません");
  }

  // Initialize filter arrays from URL
  ["material", "shape", "back", "type", "surface", "excludeCollection"].forEach(
    (filterKey) => {
      const paramValue = urlParams.get(filterKey);
      if (paramValue) {
        currentState.filters[filterKey] = paramValue
          .split(",")
          .filter((v) => v.trim());
        hasParams = true;
      }
    },
  );

  // Initialize other parameters
  const sortBy = urlParams.get("sortBy");
  if (sortBy) {
    currentState.sortBy = sortBy;
    hasParams = true;
  }

  const sortOrder = urlParams.get("sortOrder");
  if (sortOrder) {
    currentState.sortOrder = sortOrder;
    hasParams = true;
  }

  const cursor = urlParams.get("cursor");
  if (cursor) {
    currentState.cursor = cursor;
    hasParams = true;
  }

  const direction = urlParams.get("direction");
  if (direction) {
    currentState.direction = direction;
    hasParams = true;
  }

  // If we found URL params, sync the UI with the state
  if (hasParams) {
    syncUIWithState();
    return true;
  }

  return false;
}

// Function to sync UI elements with current state
function syncUIWithState() {
  // Sync checkboxes
  document
    .querySelectorAll('.page .filter-content input[type="checkbox"]')
    .forEach((input) => {
      const filterName = input.name;
      const value = input.value;
      const shouldBeChecked =
        currentState.filters[filterName] &&
        currentState.filters[filterName].includes(value);

      input.checked = shouldBeChecked;
      const checkboxVisual = input.parentNode.querySelector(".checkbox");
      if (shouldBeChecked) {
        checkboxVisual.classList.add("checked");
      } else {
        checkboxVisual.classList.remove("checked");
      }
    });

  // Sync size buttons (surface filter)
  document.querySelectorAll(".page .size-btn").forEach((btn) => {
    const value = btn.getAttribute("data-value");
    const shouldBeActive =
      currentState.filters.surface &&
      currentState.filters.surface.includes(value);

    if (shouldBeActive) {
      btn.classList.add("active");
    } else {
      btn.classList.remove("active");
    }
  });

  // Sync search input
  const searchInput = document.querySelector("#page-search-input");
  if (searchInput && currentState.title) {
    searchInput.value = currentState.title;
  }

  // Sync sort buttons
  document.querySelectorAll(".sort-btn").forEach((btn, index) => {
    btn.classList.remove("active");

    // Determine which sort button should be active
    let shouldBeActive = false;
    switch (index) {
      case 0: // 人気順 - rank asc
        shouldBeActive =
          currentState.sortBy === "rank" &&
          (currentState.sortOrder === "asc" ||
            currentState.sortOrder === "desc");
        break;
      case 1: // 価格 - min_price asc
        shouldBeActive =
          currentState.sortBy === "min_price" &&
          (currentState.sortOrder === "asc" ||
            currentState.sortOrder === "desc");
        break;
      case 2: // サイズ - number_size asc
        shouldBeActive =
          currentState.sortBy === "number_size" &&
          (currentState.sortOrder === "asc" ||
            currentState.sortOrder === "desc");
        break;
    }

    if (shouldBeActive) {
      btn.classList.add("active");
    }
  });
}
